import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/image/me-aside.jpg'


const _hoisted_1 = { class: "aside-component flex flex-vertical flex-auto" }
const _hoisted_2 = { class: "flex flex-1" }
const _hoisted_3 = { class: "content flex-vh-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "A photo of me!"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Will Baker", -1)
const _hoisted_6 = { class: "flex flex-auto social-container text-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("CV")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GitHubIcon = _resolveComponent("GitHubIcon")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!
  const _component_LinkedInIcon = _resolveComponent("LinkedInIcon")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `link-${index}`
            }, [
              _createVNode(_component_router_link, {
                to: link.url,
                class: _normalizeClass(["link", {
                                'is-selected': _ctx.currentLocation === link.url,
                            }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.title), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_LinkComponent, {
        href: "https://github.com/wjbaker101",
        title: "GitHub"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_GitHubIcon)
        ]),
        _: 1
      }),
      _createVNode(_component_LinkComponent, {
        href: "https://linkedin.com/in/wjbaker101",
        title: "LinkedIn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LinkedInIcon)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/about/cv" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}